export const y_tick_formatting = {
  fontSize: 'var(--mantine-font-size-sm)',
  fill: 'var(--mantine-color-dark-0)',
  opacity: 0.8,
}

export const x_tick_formatting = {
  fontSize: 'var(--mantine-font-size-sm)',
  fill: 'var(--mantine-color-dark-0)',
  opacity: 0.6,
}

export const Dex_Price_Colors = {
  stroke: 'var(--mantine-color-chart_a-0)',
  fill: 'var(--mantine-color-chart_a-0)',
}

export const Nav_Colors = {
  stroke: 'var(--mantine-color-chart_a-4)',
  fill: 'var(--mantine-color-chart_a-4)',
}

export const Round_Colors = {
  stroke: 'var(--mantine-color-chart_b-2)',
  fill: 'var(--mantine-color-chart_b-2)',
}

export const Discount_Colors = {
  stroke: 'var(--mantine-color-blue-4)',
  fill: 'var(--mantine-color-blue-4)',
}

export const Vault_Price_Colors = {
  stroke: 'var(--mantine-color-chestnut-2)',
  fill: 'var(--mantine-color-chestnut-2)',
}

export const Balance_Colors = {
  stroke: 'var(--mantine-color-green-5)',
  fill: 'var(--mantine-color-green-5)',
}

export const Liquidity_Colors = {
  usdc: 'var(--mantine-color-green-6)',
  token: 'var(--mantine-color-blue-6)',
}
